import { WorkflowData, WorkflowDetailData } from "../types/Workflow";
import { workflowApiUrl } from "./api";

const API_URL = "/Workflows";
const API_URL_DETAIL = "/WorkflowDetails";

export const getData = async (): Promise<WorkflowData[]> => {
  try {
    const res = await workflowApiUrl.get<WorkflowData[]>(API_URL);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get all workflows error: ${
        error.response?.data?.message || error.message
      }`
    );
    return []; // Return empty array on error
  }
};

export const getDataById = async (id: number): Promise<WorkflowData | null> => {
  try {
    const res = await workflowApiUrl.get<WorkflowData>(`${API_URL}/${id}`);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get workflow error: ${error.response?.data?.message || error.message}`
    );
    return null; // Return null on error
  }
};

export const createData = async (
  data: Partial<WorkflowData>
): Promise<WorkflowData | null> => {
  try {
    const res = await workflowApiUrl.post<WorkflowData>(API_URL, data);
    return res.data;
  } catch (error: any) {
    console.error(
      `Create workflow error: ${error.response?.data?.message || error.message}`
    );
    return null;
  }
};

export const updateData = async (
  id: number,
  data: Partial<WorkflowData>
): Promise<WorkflowData | null> => {
  try {
    const res = await workflowApiUrl.put<WorkflowData>(
      `${API_URL}/${id}`,
      data
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Update workflow error: ${error.response?.data?.message || error.message}`
    );
    return null;
  }
};

export const deleteData = async (id: number): Promise<boolean> => {
  try {
    await workflowApiUrl.delete(`${API_URL}/${id}`);
    return true;
  } catch (error: any) {
    console.error(
      `Delete workflow error: ${error.response?.data?.message || error.message}`
    );
    return false;
  }
};

export const getWorkflowDetailData = async (
  id: number
): Promise<WorkflowDetailData[]> => {
  try {
    const res = await workflowApiUrl.get<WorkflowDetailData[]>(
      `${API_URL_DETAIL}/get-workflow-details`,
      {
        params: {
          id: id,
        },
      }
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Get workflows details error: ${
        error.response?.data?.message || error.message
      }`
    );
    return []; // Return empty array on error
  }
};

export const createWorkflowDetailData = async (
  data: Partial<WorkflowDetailData>
): Promise<WorkflowDetailData | null> => {
  try {
    const res = await workflowApiUrl.post<WorkflowDetailData>(
      API_URL_DETAIL,
      data
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Create workflow detail error: ${
        error.response?.data?.message || error.message
      }`
    );
    return null;
  }
};

export const createFirstWorkflowDetailData = async (
  data: Partial<WorkflowDetailData>
): Promise<WorkflowDetailData | null> => {
  try {
    const res = await workflowApiUrl.post<WorkflowDetailData>(
      `${API_URL_DETAIL}/first-workflow`,
      data
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Create first workflow detail error: ${
        error.response?.data?.message || error.message
      }`
    );
    return null;
  }
};

export const updateWorkflowDetailData = async (
  id: number,
  data: Partial<WorkflowDetailData>
): Promise<WorkflowDetailData | null> => {
  try {
    const res = await workflowApiUrl.put<WorkflowDetailData>(
      `${API_URL_DETAIL}/${id}`,
      data
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Update workflow detail error: ${
        error.response?.data?.message || error.message
      }`
    );
    return null;
  }
};

export const moveUp = async (
  data: Partial<WorkflowDetailData>
): Promise<WorkflowDetailData | null> => {
  try {
    const res = await workflowApiUrl.post<WorkflowDetailData>(
      `${API_URL_DETAIL}/move-up`,
      data
    );
    return res.data;
  } catch (error: any) {
    console.error(
      `Move up record error: ${error.response?.data?.message || error.message}`
    );
    return null;
  }
};

export const deleteWorkflowDetailData = async (
  id: number
): Promise<boolean> => {
  try {
    await workflowApiUrl.delete(`${API_URL_DETAIL}/${id}`);
    return true;
  } catch (error: any) {
    console.error(
      `Delete workflow detail error: ${
        error.response?.data?.message || error.message
      }`
    );
    return false;
  }
};
